module.exports = __webpack_public_path__ + "img/img2.825a7c63.jpg";